import React, { useEffect, useState } from "react";
import {
  Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

const GRADES = ["18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "30L", "idoneo", "non_idoneo"];
const LABEL = { "30L": "30 e lode", idoneo: "Idoneo", non_idoneo: "Non idoneo" };

export default function GradeDialog({ open, onOpenChange, student, initial, onSubmit, submitting }) {
  const [value, setValue] = useState("");
  const [note, setNote] = useState("");

  useEffect(() => {
    if (open) {
      setValue(initial?.grade_value || "");
      setNote(initial?.examiner_note || "");
    }
  }, [open, initial]);

  function submit(e) {
    e.preventDefault();
    if (!value) return;
    onSubmit({ grade_value: value, examiner_note: note || null });
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md bg-white">
        <DialogHeader>
          <DialogTitle>{initial ? "Modifica voto" : "Verbalizza voto"}</DialogTitle>
          <DialogDescription>Studente: <b>{student?.student_name}</b> · Matricola: {student?.matricola}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-xs mb-1.5 block">Voto</Label>
            <div className="grid grid-cols-6 gap-1.5">
              {GRADES.map((g) => (
                <button
                  key={g}
                  type="button"
                  onClick={() => setValue(g)}
                  data-testid={`grade-${g}`}
                  className={`px-2 py-1.5 rounded-md text-xs font-medium border transition-colors duration-100 ${
                    value === g
                      ? (g === "non_idoneo" ? "bg-red-600 border-red-600 text-white" : "bg-[#1C352D] border-[#1C352D] text-white")
                      : "bg-white border-stone-200 hover:border-[#1C352D]"
                  } ${g === "idoneo" || g === "non_idoneo" ? "col-span-3" : ""}`}
                >{LABEL[g] || g}</button>
              ))}
            </div>
          </div>
          <div>
            <Label className="text-xs">Nota commissione (opz.)</Label>
            <Textarea rows={2} value={note} onChange={(e) => setNote(e.target.value)}/>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button>
            <Button type="submit" disabled={submitting || !value} data-testid="grade-submit" className="bg-[#1C352D] hover:bg-[#264A3E]">
              {submitting ? "Salvataggio…" : "Verbalizza"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
